import React, { useEffect, useRef, useState } from "react";
import {
  CollapsibleCardWrapper,
  CardBorderVariant,
  CardHeader,
  HeaderLeft,
  CardChevron,
  CollapsibleContent
} from "./session-card.styles";
import { Icon } from "design-system/components/icon/icon";

interface CollapsibleCardProps {
  border?: CardBorderVariant;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  onToggle?: (isExpanded: boolean) => void;
  header: React.ReactNode;
  children: React.ReactNode;
}

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  border = "default",
  collapsible = true,
  defaultExpanded = false,
  onToggle,
  header,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(
    collapsible ? defaultExpanded : true
  );
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    contentRef.current?.toggleAttribute("inert", !isExpanded);
  }, [isExpanded]);

  const handleToggle = () => {
    const nextExpanded = !isExpanded;
    setIsExpanded(nextExpanded);
    onToggle?.(nextExpanded);
  };

  return (
    <CollapsibleCardWrapper $border={border} $isExpanded={isExpanded}>
      <CardHeader>
        <HeaderLeft>{header}</HeaderLeft>
        {collapsible && (
          <CardChevron
            type="button"
            aria-label={isExpanded ? "Collapse section" : "Expand section"}
            aria-expanded={isExpanded}
            onClick={handleToggle}
            $isExpanded={isExpanded}
          >
            <Icon name="navigation-chevron-up" />
          </CardChevron>
        )}
      </CardHeader>
      <CollapsibleContent
        ref={contentRef}
        $isExpanded={isExpanded}
        aria-hidden={!isExpanded}
      >
        <div>{children}</div>
      </CollapsibleContent>
    </CollapsibleCardWrapper>
  );
};
